/*=========================================================================================
  File Name: module-notification-actions.js
  Description: Notification Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import NotificationApi from '@/api/NotificationApi.js';

export default {
	/**
	 * Lấy danh sách
	 */
	getMisaNotificationV2Token: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationApi.getAPIUrl() + '/notification-token'
		});
		if (res && res.Success && res.Data) {
			return res.Data;
		}
		return null;
	}
};
